import 'whatwg-fetch';
import { BASE_URL, CLIENT_APP_URL } from 'config';
import { apiUrls } from 'constants/urls';
import { configureRefreshFetch, fetchJSON } from './refresh-fetch';
import { ParamValueType, RequestOptions, ResponseError } from 'types/request';
import { RequestHeader } from 'constants/requests';
import Cookies from 'js-cookie';
import { StorageKey } from 'constants/localStorage';

const encodeValue = (value: ParamValueType) => {
  if (typeof value === 'object') {
    return encodeURIComponent(JSON.stringify(value));
  }

  return encodeURIComponent(value);
};

const convertParamArray = (key: string, paramArray: Array<ParamValueType>) => {
  let paramStr = '';
  paramArray.forEach((param, index) => {
    const endSymbol = paramArray?.length - 1 === index ? '' : '&';

    paramStr = paramStr + key + '=' + encodeValue(param) + endSymbol;
  });
  return paramStr;
};

const formatQueryParams = (params: Record<string, ParamValueType | ParamValueType[]>) =>
  Object.keys(params)
    .map(k => {
      const paramValue = params[k];
      return Array.isArray(paramValue)
        ? convertParamArray(encodeURIComponent(k), paramValue)
        : `${encodeURIComponent(k)}=${encodeValue(paramValue)}`;
    })
    .join('&');

const fetchJSONWithToken = (url: string, options: RequestOptions = {}) => {
  // const token = auth.getAccessToken();

  const base = process.env.NODE_ENV === 'development' ? CLIENT_APP_URL : options.baseUrl || BASE_URL;

  const headers = { ...options?.headers };

  const isJson = options.isJson ?? true;
  let optionsWithToken = { ...options };

  // if (token != null) {
  //   optionsWithToken = merge({}, options, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });
  // }

  const csrfAccessToken = Cookies.get(StorageKey.CSRF_ACCESS_TOKEN);

  if (!headers[RequestHeader.CSRF_TOKEN] && csrfAccessToken) {
    headers[RequestHeader.CSRF_TOKEN] = csrfAccessToken;
  }

  if (optionsWithToken && optionsWithToken.body && isJson) {
    optionsWithToken.body = JSON.stringify(optionsWithToken.body);
  }

  if (optionsWithToken && optionsWithToken.params) {
    const params = formatQueryParams(optionsWithToken.params);
    url = `${url}?${params}`;
  }

  optionsWithToken = Object.assign(optionsWithToken, {
    headers,
  });

  return fetchJSON(base + url, optionsWithToken);
};

const shouldRefreshToken = (error: ResponseError) => {
  return error.response.status === 401;
};

const isForbidden = (error: ResponseError) => {
  return error.response.status === 403;
};

const refreshToken = async () => {
  const csrfRefreshToken = Cookies.get(StorageKey.CSRF_REFRESH_TOKEN);

  return (
    fetchJSONWithToken(apiUrls.auth.refresh, {
      method: 'POST',
      headers: {
        [RequestHeader.CSRF_TOKEN]: csrfRefreshToken,
      },
    })
      // .then(response => {
      //   auth.setAccessToken(response.access_token, { disableReload: true });
      // })
      .catch(error => {
        // Clear token and continue with the Promise catch chain
        // auth.clearTokens();
        throw error;
      })
  );
};

const request = configureRefreshFetch({
  fetch: fetchJSONWithToken,
  shouldRefreshToken,
  refreshToken,
  isForbidden,
});

export default request;
